import classNames from 'classnames';
import { FC, memo, ReactElement, useMemo } from 'react';
import { dashboardPreventId } from '../../constants/dashboard';
import { COLORS } from '~/constants/styles';
import { localeStore } from '~/mobx/localesStore';
import { numberWithDigitSeparator } from '~/utils/formatter';
import { ICustomTooltipProps } from '~/view/components/Controls/CustomTooltip/CustomTooltip';
import TooltipIcon from '~/view/components/TooltipIcon/TooltipIcon';
import './style.scss';

interface IProps {
  header: string;
  tooltip: Partial<ICustomTooltipProps>;
  value: number;
  percent: number;
}

const DashboardPlateNumberBlock: FC<IProps> = (props: IProps): ReactElement => {
  const percentColor = useMemo((): string => `color-${props.percent >= 0 ? COLORS.GREEN : COLORS.RED}`, [props.percent]);
  const percentValue = useMemo((): string => {
    const value: string = numberWithDigitSeparator(props.percent) + '%';
    return props.percent > 0 ? '+' + value : value;
  }, [props.percent]);

  return (
    <div className="d-flex flex-column gap-5">
      <div className="d-flex flex-row align-items-center gap-10">
        <p className="dashboard-plate-number__title letter-spacing-12">{localeStore.t(props.header)}</p>
        {/* eslint-disable-next-line react/jsx-props-no-spreading */}
        <TooltipIcon {...props.tooltip} iconId={dashboardPreventId} iconSize={18} />
      </div>

      <div className="d-flex flex-row align-items-center gap-15">
        <p className="dashboard-plate-number__value">{numberWithDigitSeparator(props.value)}</p>
        <p className={classNames('dashboard-plate-number__value', percentColor)}>{percentValue}</p>
      </div>
    </div>
  );
};

export default memo(DashboardPlateNumberBlock);
